import React from 'react';
import { connect } from 'react-redux';
import { DataBlocks, I18n } from 'components';
import { compose } from 'redux';
import { withRenderFlag } from '@beef/react';

import { getFTTBAdditionalServices, getFTTBExtraServices } from 'pages/Internet/store/selectors';
import {
  FirewallCardConnected, SocialInternetConnected,
  AdditionalServicesConnected, AdditionalServicesPopup,
} from './containers';
import { useIsMobileWidth } from '../../../../utils/hooks/useIsMobile';

const _ServiceBlock = () => {
  const isMobile = useIsMobileWidth();

  return (
    <DataBlocks.Block title={<I18n path="internet.services.blockTitle" />}>
      <FirewallCardConnected isMobile={isMobile} />
      <AdditionalServicesConnected isMobile={isMobile} />
      <SocialInternetConnected isMobile={isMobile} />

      <AdditionalServicesPopup />
    </DataBlocks.Block>
  );
};

const mapStateToProps = (state) => ({
  shouldRender: !!getFTTBAdditionalServices(state).length || !!getFTTBExtraServices(state).length,
});

export const ServiceBlock = compose(
  connect(mapStateToProps),
  withRenderFlag,
)(_ServiceBlock);
